export let lastId = 0;

export function uniqueComponentId(prefix = "cbsk_id_"): string {
  lastId++;

  return `${prefix}${lastId}`;
}
